import script from "./TicketDesigner.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketDesigner.vue?vue&type=script&setup=true&lang=js"

import "./TicketDesigner.vue?vue&type=style&index=0&id=cb0af592&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb0af592"]])

export default __exports__